<div
  #container
  class="card w-100 overflow-x"
>
  <div class="p-0">
    @if (!isPlanningModule) {
      @if (forecastData && forecastData.length > 0) {
        <div
          [ngClass]="{ fontSizeReport: fromReport }"
          class="forecast-chart"
        >
          @if (showWeatherTable === 'full') {
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">
                {{ 'PLANNING.PARK.WEATHER' | translate }}
              </div>
              @if (!forecastData[0].weather || forecastData[0].weather.length === 0) {
                {{ 'PLANNING.PARK.NO_WEATHER_DATA' | translate }}
              }
              @if (forecastData[0].weather && forecastData[0].weather.length > 0) {
                @for (data of forecastData[0].weather; track $index) {
                  <div class="text-center textitem">
                    <i class="{{ data | weatherIcon }} text-primary font-size-normal"></i>
                    @if (!data) {
                      <div>-</div>
                    }
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">{{ 'PLANNING.PARK.TEMPERATURE' | translate }} [°C]</div>
              @if (!forecastDataProcessed.temperature || forecastDataProcessed.temperature.length === 0) {
                {{ 'PLANNING.PARK.NO_TEMP_DATA' | translate }}
              }
              @if (forecastDataProcessed.temperature && forecastDataProcessed.temperature.length > 0) {
                @for (data of forecastDataProcessed.temperature; track $index) {
                  <div class="text-center textitem">
                    {{ data ? (data | number: '1.0-0' | customNumberFormat) : '-' }}
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">{{ 'PLANNING.PARK.WIND_SPEED' | translate }} [m/s]</div>
              @if (!forecastDataProcessed.windSpeed || forecastDataProcessed.windSpeed.length === 0) {
                {{ 'PLANNING.PARK.NO_WIND_SPEED_DATA' | translate }}
              }
              @if (forecastDataProcessed.windSpeed && forecastDataProcessed.windSpeed.length > 0) {
                @for (data of forecastDataProcessed.windSpeed; track $index) {
                  <div class="text-center textitem">
                    {{ data ? (data | number: '1.1-1' | customNumberFormat) : '-' }}
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">
                {{ 'PLANNING.PARK.WIND_DIR' | translate }}
              </div>
              @if (!forecastDataProcessed.windDirection || forecastDataProcessed.windDirection.length === 0) {
                {{ 'PLANNING.PARK.NO_WIND_DIR_DATA' | translate }}
              }
              @if (forecastDataProcessed.windDirection && forecastDataProcessed.windDirection.length > 0) {
                @for (data of forecastDataProcessed.windDirection; track $index) {
                  <div
                    tooltip="{{ data | number: '1.1-1' | customNumberFormat }}°"
                    class="text-center textitem"
                  >
                    @if (data) {
                      <i
                        class="material-icons wind-icons"
                        [ngStyle]="rotate(data)"
                      >
                        navigation
                      </i>
                    }
                    @if (!data) {
                      <div>-</div>
                    }
                  </div>
                }
              }
            </div>
            @if (showRevenues) {
              <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
                <div class="font-weight-bold headeritem">
                  {{ 'PLANNING.PARK.REV_LOSS' | translate }}
                </div>
                @if (!forecastDataProcessed.revenueLosses || forecastDataProcessed.revenueLosses.length === 0) {
                  {{ 'PLANNING.PARK.NO_REV_LOSS_DATA' | translate }}
                }
                @if (forecastDataProcessed.revenueLosses && forecastDataProcessed.revenueLosses.length > 0) {
                  @for (data of forecastDataProcessed.revenueLosses; track $index) {
                    <div
                      tooltip="{{ data | number: '1.1-2' | customNumberFormat }} {{ '' | currencyPortfolio }}"
                      class="text-center textitemwide"
                    >
                      {{ data ? (data | number: '1.0-0' | customNumberFormat) + (' ' | currencyPortfolio) : '-' }}
                    </div>
                  }
                }
              </div>
            }
          }
          @if (showWeatherTable === 'small') {
            <div class="d-flex justify-content-between align-items-center table-row text-primary tablePosSmallTable">
              @if (!forecastData[0].weather || forecastData[0].weather.length === 0) {
                {{ 'PLANNING.PARK.NO_WEATHER_DATA' | translate }}
              }
              @if (forecastData[0].weather && forecastData[0].weather.length > 0) {
                @for (data of forecastData[0].weather; track $index; let i = $index) {
                  <div class="text-center">
                    <ng-template #tooltip2>
                      <span class="text-primary font-weight-bold">
                        {{ from + i * (days.length === 1 ? 2 * 3600000 : 12 * 3600000) | dateTimeFormatPipe: 'dmt' }}
                        <br />
                        {{ forecastDataProcessed.temperature[i] | number: '1.0-0' | customNumberFormat }}°C
                      </span>
                    </ng-template>
                    <i
                      [appCustomTooltip]="tooltip2"
                      class="{{ data | weatherIcon }} text-primary font-size-normal"
                    ></i>
                    @if (!data) {
                      <div style="width: 12px">-</div>
                    }
                  </div>
                }
              }
            </div>
            <div class="d-flex align-items-center table-row text-primary tablePosSmallTable wind-dir">
              @if (!forecastDataProcessed.windDirection || forecastDataProcessed.windDirection.length === 0) {
                {{ 'PLANNING.PARK.NO_WIND_DIR_DATA' | translate }}
              }
              @if (forecastDataProcessed.windDirection && forecastDataProcessed.windDirection.length > 0) {
                <div class="px-3 -flex align-items-center">WD</div>
                <div class="d-flex justify-content-between align-items-center w-100">
                  @for (data of forecastDataProcessed.windDirection; track $index; let i = $index) {
                    <div class="text-center">
                      <ng-template #tooltip3>
                        <span class="text-primary">
                          {{ data | number: '1.1-1' | customNumberFormat }}°
                          <br />
                        </span>
                      </ng-template>
                      @if (data) {
                        <i
                          [appCustomTooltip]="tooltip3"
                          class="material-icons wind-icons"
                          [ngStyle]="rotate(data)"
                        >
                          navigation
                        </i>
                      }
                      @if (!data) {
                        <div style="width: 12px">-</div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }

    <div
      #powerChart
      [ngClass]="{ chartpos: showWeatherTable === 'full', 'power-chart': !fromReport }"
    >
      @if (data.length > 0) {
        <highcharts-chart
          class="w-100 d-block"
          [Highcharts]="highcharts"
          [options]="chartOptions"
          [callbackFunction]="chartCallback"
        ></highcharts-chart>
      }
    </div>

    @if (isPlanningModule) {
      @if (forecastData && forecastData.length > 0) {
        <div [ngClass]="{ fontSizeReport: fromReport }">
          @if (showWeatherTable === 'full') {
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">
                {{ 'PLANNING.PARK.WEATHER' | translate }}
              </div>
              @if (!forecastData[0].weather || forecastData[0].weather.length === 0) {
                {{ 'PLANNING.PARK.NO_WEATHER_DATA' | translate }}
              }
              @if (forecastData[0].weather && forecastData[0].weather.length > 0) {
                @for (data of forecastData[0].weather; track $index) {
                  <div class="text-center textitem">
                    <i class="{{ data | weatherIcon }} text-primary font-size-normal"></i>
                    @if (!data) {
                      <div>-</div>
                    }
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">{{ 'PLANNING.PARK.TEMPERATURE' | translate }} [°C]</div>
              @if (!forecastDataProcessed.temperature || forecastDataProcessed.temperature.length === 0) {
                {{ 'PLANNING.PARK.NO_TEMP_DATA' | translate }}
              }
              @if (forecastDataProcessed.temperature && forecastDataProcessed.temperature.length > 0) {
                @for (data of forecastDataProcessed.temperature; track $index) {
                  <div class="text-center textitem">
                    {{ data ? (data | number: '1.0-0' | customNumberFormat) : '-' }}
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">{{ 'PLANNING.PARK.WIND_SPEED' | translate }} [m/s]</div>
              @if (!forecastDataProcessed.windSpeed || forecastDataProcessed.windSpeed.length === 0) {
                {{ 'PLANNING.PARK.NO_WIND_SPEED_DATA' | translate }}
              }
              @if (forecastDataProcessed.windSpeed && forecastDataProcessed.windSpeed.length > 0) {
                @for (data of forecastDataProcessed.windSpeed; track $index) {
                  <div class="text-center textitem">
                    {{ data ? (data | number: '1.1-1' | customNumberFormat) : '-' }}
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
              <div class="font-weight-bold headeritem">
                {{ 'PLANNING.PARK.WIND_DIR' | translate }}
              </div>
              @if (!forecastDataProcessed.windDirection || forecastDataProcessed.windDirection.length === 0) {
                {{ 'PLANNING.PARK.NO_WIND_DIR_DATA' | translate }}
              }
              @if (forecastDataProcessed.windDirection && forecastDataProcessed.windDirection.length > 0) {
                @for (data of forecastDataProcessed.windDirection; track $index) {
                  <div
                    tooltip="{{ data | number: '1.1-1' | customNumberFormat }}°"
                    class="text-center textitem"
                  >
                    @if (data) {
                      <i
                        class="material-icons wind-icons"
                        [ngStyle]="rotate(data)"
                      >
                        navigation
                      </i>
                    }
                    @if (!data) {
                      <div>-</div>
                    }
                  </div>
                }
              }
            </div>
            @if (showRevenues) {
              <div class="d-flex justify-content-between align-items-center table-row text-primary pl-3 pr-3">
                <div class="font-weight-bold headeritem">
                  {{ 'PLANNING.PARK.REV_LOSS' | translate }}
                </div>
                @if (!forecastDataProcessed.revenueLosses || forecastDataProcessed.revenueLosses.length === 0) {
                  {{ 'PLANNING.PARK.NO_REV_LOSS_DATA' | translate }}
                }
                @if (forecastDataProcessed.revenueLosses && forecastDataProcessed.revenueLosses.length > 0) {
                  @for (data of forecastDataProcessed.revenueLosses; track $index) {
                    <div
                      tooltip="{{ data | number: '1.1-2' | customNumberFormat }} {{ '' | currencyPortfolio }}"
                      class="text-center textitemwide"
                    >
                      {{ data ? (data | number: '1.0-0' | customNumberFormat) + (' ' | currencyPortfolio) : '-' }}
                    </div>
                  }
                }
              </div>
            }
          }
          @if (showWeatherTable === 'small') {
            <div class="d-flex justify-content-between align-items-center table-row text-primary tablePosSmallTable">
              @if (!forecastData[0].weather || forecastData[0].weather.length === 0) {
                {{ 'PLANNING.PARK.NO_WEATHER_DATA' | translate }}
              }
              @if (forecastData[0].weather && forecastData[0].weather.length > 0) {
                @for (data of forecastData[0].weather; track $index; let i = $index) {
                  <div class="text-center">
                    <ng-template #tooltip4>
                      <span class="text-primary font-weight-bold">
                        {{ from + i * (days.length === 1 ? 2 * 3600000 : 12 * 3600000) | dateTimeFormatPipe: 'dmt' }}
                        <br />
                        {{ forecastDataProcessed.temperature[i] | number: '1.0-0' | customNumberFormat }}°C
                      </span>
                    </ng-template>
                    <i
                      [appCustomTooltip]="tooltip4"
                      class="{{ data | weatherIcon }} text-primary font-size-normal"
                    ></i>
                    @if (!data) {
                      <div style="width: 12px">-</div>
                    }
                  </div>
                }
              }
            </div>
            <div class="d-flex justify-content-between align-items-center table-row text-primary tablePosSmallTable">
              @if (!forecastDataProcessed.windDirection || forecastDataProcessed.windDirection.length === 0) {
                {{ 'PLANNING.PARK.NO_WIND_DIR_DATA' | translate }}
              }
              @if (forecastDataProcessed.windDirection && forecastDataProcessed.windDirection.length > 0) {
                @for (data of forecastDataProcessed.windDirection; track $index; let i = $index) {
                  <div class="text-center">
                    <ng-template #tooltip5>
                      <span class="text-primary font-weight-bold">
                        {{ data | number: '1.1-1' | customNumberFormat }}°
                        <br />
                      </span>
                    </ng-template>
                    @if (data) {
                      <i
                        [appCustomTooltip]="tooltip5"
                        class="material-icons wind-icons"
                        [ngStyle]="rotate(data)"
                      >
                        navigation
                      </i>
                    }
                    @if (!data) {
                      <div style="width: 12px">-</div>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    }
    <!-- Weather forecast -->
  </div>
</div>
